export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	DASHBOARD = 'dashboard',
	PRODUCTS = 'products',
	PRODUCT_TYPES = 'product-types',

	ADMINS = 'admins',

	ATTRIBUTE_GROUPS = 'attribute-groups',
	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	COLORS = 'colors',
	MATERIALS = 'materials',
	MODELS = 'models',
	ROLES = 'roles',
}
